module.exports = __webpack_public_path__ + "media/images/clutch_kits/RUEN-a45178c0ea3c620d5a5193fbd4e9c091.jpg";